import { Paper } from '@mui/material';
import React from 'react'

const GameFactIcon_Dsas = ({src, onClick, id}) => {

    const onMouseOver = (e) => {
        let elem = e.target

            elem.style.cursor = 'pointer'
            elem.style.transform = 'scale(1.1)'
            elem.style.zIndex = '100'

    }

    const onMouseOut = (e) => {
        let elem = e.target

            elem.style.transform = 'scale(1)'
            elem.style.zIndex = '1'
    }

    return (
            <img src={src} key={id} onMouseOver={onMouseOver} onMouseOut={onMouseOut} onClick={onClick} width="95%" alt='Icon'/>
    )

}

export default GameFactIcon_Dsas